(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('BlockedPhoneDeleteController',BlockedPhoneDeleteController);

    BlockedPhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'BlockedPhone'];

    function BlockedPhoneDeleteController($uibModalInstance, entity, BlockedPhone) {
        var vm = this;

        vm.blockedPhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BlockedPhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
